var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBottlePills = function SvgIconBottlePills(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 50 50",
    height: 512,
    viewBox: "0 0 50 50",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.6 40.6v1.8c0 1.3-1.9 2.4-4.2 2.4s-4.2-1.1-4.2-2.4v-1.8z",
    fill: "#ffc280"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4,
    cy: 40.6,
    fill: "#f9d5b4",
    rx: 4.2,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.5 38.5c-.1 0-.2-.1-.3-.1l-4.2 4.2c.1 0 .2.1.3.1z",
    fill: "#ffc280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.5 38.5-4.2 4.2c.1 0 .2.1.3.1l4.2-4.2c-.1 0-.2 0-.3-.1z",
    fill: "#d89c60"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m35 32.2v1.8c0 1.3-1.9 2.4-4.2 2.4s-4.2-1.1-4.2-2.4v-1.8z",
    fill: "#ffc280"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.8,
    cy: 32.2,
    fill: "#f9d5b4",
    rx: 4.2,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32.9 30.1c-.1 0-.2-.1-.3-.1l-4.2 4.2c.1 0 .2.1.3.1z",
    fill: "#ffc280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.9 30.1-4.2 4.2c.1 0 .2.1.3.1l4.2-4.2c-.1-.1-.2-.1-.3-.1z",
    fill: "#d89c60"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.4 38.9 7.1.4c1.9.1 2.9 2.2 1.9 3.8-.5.7-1.3 1.2-2.2 1.1l-7.1-.4c-1.9-.1-2.9-2.2-1.9-3.8.5-.7 1.3-1.1 2.2-1.1z",
    fill: "#025daf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.4 38.9 3.2.2c1.2.8 1.7 2.4.8 3.8-.3.5-.8.9-1.4 1.1l-2.9-.2c-1.9-.1-2.9-2.2-1.9-3.8.5-.7 1.3-1.1 2.2-1.1z",
    fill: "#9de5fc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.6 36.1 5.6-4.4c1.5-1.2 1.1-3.5-.6-4.2-.8-.3-1.7-.2-2.4.4l-5.6 4.4c-1.5 1.2-1.1 3.5.6 4.2.7.3 1.7.1 2.4-.4z",
    fill: "#025daf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.6 36.1 2.5-2c.5-1.3 0-3-1.5-3.6-.6-.2-1.2-.2-1.8-.1l-2.3 1.8c-1.5 1.2-1.1 3.5.6 4.2.8.4 1.8.2 2.5-.3z",
    fill: "#9de5fc"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40.4 17.2v23.1c0 4.9-6.9 9.3-15.3 9.3-8.5 0-15.4-4.4-15.4-9.3v-23.1z",
    fill: "#d8d8d8",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25 48c-8.5 0-15.4-4.4-15.4-9.3v1.6c0 4.9 6.9 9.3 15.4 9.3s15.3-4.4 15.3-9.3v-1.6c.1 5-6.8 9.3-15.3 9.3z",
    fill: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 17.2,
    fill: "#d8d8d8",
    rx: 15.4,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.4 11.1v4.9c0 4 5.6 7.3 12.6 7.3 6.9 0 12.6-3.3 12.6-7.3v-4.9z",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.6 8.3v4.6c0 4.3-6.1 7.8-13.5 7.8-7.5 0-13.6-3.5-13.6-7.8v-4.6z",
    fill: "#e22020"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 8.3,
    fill: "#ff413c",
    rx: 13.6,
    ry: 7.8
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBottlePills, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-bottle-pills.99eac494.svg";
export { ForwardRef as ReactComponent };